import React from "../../__compat__/react/main.entry.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { pickDataProps, pickAriaProps, pickComponentCommonProps, } from "../../interfaces/commonProps.mjs.mjs";
import { useLocale } from "../LocaleProvider/index.mjs.mjs";
import { PaginationVariant, StartEllipsis, EndEllipsis, } from "./Pagination.types.mjs.mjs";
import { StyledPaginationItem, StyledContainer, StyledPagination, StyledIconContainer, StyledArrow, StyledCurrentPage, StyledCompactWrapper, } from "./Pagination.styles.mjs.mjs";
import { getExtendedPages } from "./getExtendedPages.mjs.mjs";
import { getNormalPages } from "./getNormalPages.mjs.mjs";
const Arrow = () => (React.createElement(StyledArrow, { xmlns: "http://www.w3.org/2000/svg", width: "8", height: "13", viewBox: "0 0 8 13" },
    React.createElement("path", { stroke: "currentColor", strokeWidth: "1px", fill: "none", d: "M1.5,1 l6,6 l-6,6" })));
export const Pagination = React.forwardRef(({ children: renderItem = (props) => (React.createElement("button", { ...props })), variant = PaginationVariant.normal, count, page, nav = false, navLabel, onChange: handleChange = () => { }, carouselMode, ...restProps }, ref) => {
    const { pagination: locale } = useLocale();
    const isFirstPage = page === 1;
    const isLastPage = page === count;
    const prevPageIndex = page - 1;
    const nextPageIndex = page + 1;
    return (React.createElement(StyledContainer, { ref: ref, as: nav ? 'nav' : 'div', ...(nav ? { 'aria-label': navLabel || locale.ariaLabel } : {}), outerSpacing: useSpacing(restProps), ...pickComponentCommonProps(restProps), ...pickDataProps(restProps), ...pickAriaProps(restProps) },
        React.createElement(StyledPagination, { count: count, variant: variant },
            React.createElement(StyledPaginationItem, null, renderItem({
                page: prevPageIndex,
                disabled: carouselMode ? false : isFirstPage,
                'aria-disabled': carouselMode ? false : isFirstPage,
                'aria-label': locale.ariaGoToPrevious,
                onClick: carouselMode && isFirstPage
                    ? (event) => handleChange(count, event)
                    : (event) => handleChange(prevPageIndex, event),
                children: (React.createElement(React.Fragment, null,
                    React.createElement(StyledIconContainer, { prev: true },
                        React.createElement(Arrow, null)),
                    variant === PaginationVariant.minimalWithLabels &&
                        locale.previous)),
            })),
            variant === PaginationVariant.compact && (React.createElement(StyledPaginationItem, null,
                React.createElement(StyledCompactWrapper, null,
                    React.createElement(StyledCurrentPage, { "aria-current": "page" }, page),
                    "/",
                    count))),
            variant === PaginationVariant.normal &&
                getNormalPages({
                    currentPage: page,
                    totalPages: count,
                }).map((item) => {
                    const isCurrentPage = item === page;
                    return (React.createElement(StyledPaginationItem, { key: `item__${item}__${count}` }, renderItem({
                        page: item,
                        'aria-disabled': false,
                        'aria-current': isCurrentPage ? 'page' : false,
                        'aria-label': isCurrentPage
                            ? locale.ariaCurrentPage(item)
                            : locale.ariaGoToPage(item),
                        onClick: (event) => handleChange(item, event),
                        children: item,
                    })));
                }),
            variant === PaginationVariant.extended &&
                getExtendedPages({
                    currentPage: page,
                    totalPages: count,
                }).map((item) => {
                    const isCurrentPage = item === page;
                    return (React.createElement(StyledPaginationItem, { key: `item__${item}__${count}` }, item === StartEllipsis || item === EndEllipsis ? (React.createElement("span", null, locale.ellipsis)) : (renderItem({
                        page: item,
                        'aria-disabled': false,
                        'aria-current': isCurrentPage ? 'page' : false,
                        'aria-label': isCurrentPage
                            ? locale.ariaCurrentPage(item)
                            : locale.ariaGoToPage(item),
                        onClick: (event) => handleChange(item, event),
                        children: item,
                    }))));
                }),
            React.createElement(StyledPaginationItem, null, renderItem({
                page: nextPageIndex,
                disabled: carouselMode ? false : isLastPage,
                'aria-disabled': carouselMode ? false : isLastPage,
                'aria-label': locale.ariaGoToNext,
                onClick: carouselMode && isLastPage
                    ? (event) => handleChange(1, event)
                    : (event) => handleChange(nextPageIndex, event),
                children: (React.createElement(React.Fragment, null,
                    variant === PaginationVariant.minimalWithLabels &&
                        locale.next,
                    React.createElement(StyledIconContainer, { next: true },
                        React.createElement(Arrow, null)))),
            })))));
});
Pagination.displayName = 'Pagination';
//# sourceMappingURL=Pagination.mjs.mjs.map